import React from 'react';
import { PEILink } from '@/common';
import styles from '@/styles/MainNavbar.module.scss';
import { mainNavigationElements } from '@/common';

export const MainNavbar = () => {
  return (
    <nav className={styles['primary-navigation__container']}>
      <ul className={styles['primary-navigation']}>
        {React.Children.toArray(
          mainNavigationElements?.map((listItem) => {
            return (
              <li className={styles['primary-navigation__item']}>
                <PEILink href={listItem.url} className={styles['primary-navigation__item__anchor']}>
                  {listItem.title}
                </PEILink>
              </li>
            );
          })
        )}
      </ul>
    </nav>
  );
};
